<template>
    <div class="mu-textarea-variable">
        <!-- Textarea -->
        <textarea ref="textarea" class="textarea" v-model="mutableMessage" v-on:keyup="changeMessage" @change="changeMessage"></textarea>
        <p class="textarea-count">Você já digitou {{ countChars(mutableMessage) }} caracteres</p>

        <!-- Controle das variáveis -->
        <mu-button ref="button" color="#ccc" textColor="#333" small @click="open = !open"># Variáveis</mu-button>

        <!-- Popover com a lista de variáveis -->
        <mu-popover placement="top" :open.sync="open" :trigger="trigger">
            <mu-list>
                <mu-list-item button v-for="(item, key) in variables" :key="key" @click="addVariable(item)">
                    <mu-list-item-title>{{ item }}</mu-list-item-title>
                </mu-list-item>
            </mu-list>
        </mu-popover>

    </div>
</template>

<script>
    export default {
        name: 'mu-textarea-variable',
        // props: ['message'],
        props: {
            message: {
                type: String
            },
            slug: {
                type: Boolean,
                default: false
            },
            typeMessage: {
                type: Number
            }
        },

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                mutableMessage: '',
                open: false,
                trigger: null,
                variables: [
                    '#NOME#',
                    '#VAR1#',
                    '#VAR2#',
                    '#VAR3#'
                ]
            }
        },

        // ╦ ╦╔═╗╔╦╗╔═╗╦ ╦
        // ║║║╠═╣ ║ ║  ╠═╣
        // ╚╩╝╩ ╩ ╩ ╚═╝╩ ╩

        watch: {
            message () {
                this.mutableMessage = this.message
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            this.trigger = this.$refs.button.$el
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            /**
             * Adiciona a variável ao textarea onde estiver o focus
             */
            addVariable (variable) {
                const textarea = this.$refs.textarea
                const start = this.mutableMessage.substring(0, textarea.selectionStart)
                const end = this.mutableMessage.substring(textarea.selectionStart)
                const text = start + variable + end
                this.mutableMessage = text
                this.open = false
                this.setFocus(variable)
                this.changeMessage()
            },

            /**
             * Remove os caracteres especiais
             */
            slugMessage () {
                if (this.slug) {
                    this.mutableMessage = this.strSlug(this.mutableMessage)
                    this.setFocus()
                }
            },

            /**
             * Chama o evento para atualizar a mensagem
             */
            changeMessage () {
                this.formMessageSlug()
                this.$emit('sendMessage', this.mutableMessage)
            },

            /**
             * Mantem o focus no lugar correto
             */
            setFocus (variable = null) {
                const textarea = this.$refs.textarea
                const cursorPosition = textarea.selectionEnd
                textarea.focus()
                this.$nextTick(() => {
                    textarea.selectionEnd = cursorPosition + (variable ? variable.length : 0)
                })
            },

            /**
             * Formata a mensagem removendo caracteres especiais, etc...
             */
            formMessageSlug () {
                if (this.typeMessage === 4) {
                    return
                }

                this.mutableMessage = this.strSlug(this.mutableMessage)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../assets/stylus/bootstrap.styl'

    .mu-textarea-variable
        width 100%

        label
            color #757575
            font-size 13px !important

        .textarea
            border 1px #ccc solid
            background transparent
            width 100%
            height 120px
            padding 5px 0
            text-indent 5px

            &:focus
                border 1px $primary solid

        .mu-button
            margin-left 0

    .textarea-count
        font-size 12px
        margin 0 0 10px 0

</style>
